import React, { useEffect, useMemo } from 'react';
import ContentTypeFactory from './factory';
import parseStorageHtml from './parseStorageHtml';
// import useTrendingSearches from './useTrendingSearches';

/**
 * Page Builder component for rendering Page Builder master storage format in React
 *
 * @param data
 * @returns {*}
 * @constructor
 */
export default function PageBuilder(_ref) {
  var {
    html,
    classes,
    htmlJson
  } = _ref;
  var data = useMemo(() => parseStorageHtml(html), [html]);
  useEffect(() => {
    if (document.getElementsByClassName('woobox-offer').length > 0) {
      window.woobox(window.document, 'script', 'woobox-sdk');
    }
  });
  return data.children.map((child, i) => {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.root,
      key: i
    }, /*#__PURE__*/React.createElement(ContentTypeFactory, {
      data: child,
      htmlJson: htmlJson
    }));
  });
}